export default __webpack_public_path__ + "static/media/hero-img-new.08586fc7.png";